/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable complexity */
import React from 'react';
import { List, Spin, Tooltip } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { findIndex, isEmpty } from 'lodash';
import InfiniteScroll from 'react-infinite-scroller';
import './style.scss';
import { arrayOf, bool, func, number, oneOfType, shape, string } from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-light-svg-icons';
import MapperServiceEmptyBlock from '../EmptyBlock';
import ProfileListItem from '../profileListItem';

/**
 * ProfileList Component
 * records -> records to show in modal
 * hasMore -> bool if more records exists
 * loading -> bool to check when api is loading
 * toggleItemSelection -> function to call after selecting a record
 * isVFXEnabled -> bool to check if VFX is enabled
 * hasRecommendations -> to check if the current records are profiles or recommendations
 * isEmptyQuery -> is the default query of teh record is empty
 * isEmptyDefaultQueryState -> empty state when no default value is provided
 * isSelectionEnabled - if this is true, profile will be selectable
 * isMultipleSelectionEnabled - If set to true, multiple profiles will be selectable
 * selectedRecords - If multiple selection is enabled, this will track selected profiles
 */
function ProfileList({
  records,
  hasMore,
  loading,
  loadMore,
  isVFXEnabled,
  selectedItems,
  selectedRecords,
  emptyBlockTextArr,
  hasRecommendations,
  isSelectionEnabled,
  toggleItemSelection,
  disableSelectedItems,
  isEmptyDefaultQueryState,
  redirectToProfileEnabled,
  isMultipleSelectionEnabled,
  onlyAllowUserWithEmailAddress,
}) {
  /**
   * This function will check that previous API call done loading and if yes it'll load more profiles
   */
  function handleViewMore() {
    if (loading) return;
    loadMore();
  }

  /**
   * Callback function when some profile gets selected
   * @param {*} record
   */
  function selectRecord(record) {
    if (isSelectionEnabled) {
      toggleItemSelection(record);
    }

    if (redirectToProfileEnabled) {
      window.open(record.profile_url, '_blank');
    }
  }

  return (
    <div className="mapper-profile-list">
      <If condition={hasRecommendations && !isEmptyDefaultQueryState}>
        <p className="mapper-profile-list-title arc-color-B55 arc-H100 arc-font-weight-bold">
          Recommendations:
          <Tooltip
            title="We compare names and
          aliases (like a nickname or maiden name) to
          suggest a record that might belong to this person">
            <FontAwesomeIcon className="ml8" icon={faQuestionCircle} />
          </Tooltip>
        </p>
      </If>
      <div className={`mapper-scrollable-list ${isEmpty(selectedRecords) ? '' : 'mapper-profile-list-bottom-space'}`}>
        <InfiniteScroll initialLoad={false} hasMore={false} useWindow={false} loadMore={() => {}}>
          <List
            dataSource={records}
            itemLayout="horizontal"
            loading={false}
            locale={{
              emptyText: <MapperServiceEmptyBlock emptyBlockTextArr={emptyBlockTextArr} />,
            }}
            renderItem={(record) => (
              <List.Item
                key={record.id}
                onClick={() => selectRecord(record)}
                className="arc-cursor-p pt16 pb16 pl20 pr20">
                <ProfileListItem
                  record={record}
                  isVFXEnabled={isVFXEnabled}
                  selectedItems={selectedItems}
                  isActionEnabled={isSelectionEnabled}
                  disableSelectedItems={disableSelectedItems}
                  isMultipleSelectionEnabled={isMultipleSelectionEnabled}
                  onlyAllowUserWithEmailAddress={onlyAllowUserWithEmailAddress}
                  isSelected={findIndex(selectedRecords, (val) => val.id === record.id) > -1}
                />
              </List.Item>
            )}>
            {loading && hasMore && <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />}
          </List>
        </InfiniteScroll>
        <If condition={!hasRecommendations && !isEmptyDefaultQueryState && hasMore && !loading}>
          <div className="view-more-container arc-text-align-l pt16 pb24 pl20">
            <span className="arc-color-primary arc-cursor-p" onClick={handleViewMore}>
              View more
            </span>
          </div>
        </If>
      </div>
    </div>
  );
}

ProfileList.propTypes = {
  hasMore: oneOfType([string, bool]),
  loading: bool,
  records: arrayOf(
    shape({
      is_registered: bool,
      educations: arrayOf(
        shape({
          id: number,
          class_year: number,
        }),
      ),
      role: string,
    }),
  ),
  toggleItemSelection: func.isRequired,
  isVFXEnabled: bool,
  hasRecommendations: bool,
  emptyBlockTextArr: string,
  loadMore: func,
  isEmptyDefaultQueryState: bool,
  isSelectionEnabled: bool,
  disableSelectedItems: bool,
  isMultipleSelectionEnabled: bool,
  selectedRecords: arrayOf(shape()),
  selectedItems: arrayOf(shape()),
  redirectToProfileEnabled: bool,
  onlyAllowUserWithEmailAddress: bool,
};
ProfileList.defaultProps = {
  hasMore: false,
  loading: false,
  records: [],
  isVFXEnabled: false,
  hasRecommendations: true,
  emptyBlockTextArr: '',
  loadMore: () => {},
  isEmptyDefaultQueryState: false,
  isSelectionEnabled: true,
  isMultipleSelectionEnabled: false,
  selectedItems: [],
  selectedRecords: [],
  disableSelectedItems: false,
  redirectToProfileEnabled: false,
  onlyAllowUserWithEmailAddress: false,
};

export default ProfileList;
